import moment from 'config/moment'

type DateLike = string | Date | null | undefined

export const compareStrings = (
  a: string | null | undefined,
  b: string | null | undefined,
): number => {
  const strA = a ?? ''
  const strB = b ?? ''
  if (strA < strB) return -1
  if (strA > strB) return 1
  return 0
}

export const compareNullableDates = (a: DateLike, b: DateLike): number => {
  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  const dateA = moment(a)
  const dateB = moment(b)
  if (dateA.isBefore(dateB)) return -1
  if (dateA.isAfter(dateB)) return 1
  return 0
}

export const createDateSort = <T>(getValue: (row: T) => DateLike) => (a: T, b: T): number =>
  compareNullableDates(getValue(a), getValue(b))

export const createStringSort = <T>(getValue: (row: T) => string | null | undefined) => (
  a: T,
  b: T,
): number => compareStrings(getValue(a), getValue(b))
